/*
 * @@Description: 垂直滚动
 * @@Author: MuYang
 * @Date: 2021-08-09 17:25:34
 * @LastEditTime: 2021-09-01 16:11:03
 */
/* 垂直滚动 */
export default {
  name: 'vertical-scroll',
  props: {
    maxHeight: {
      type: ['string, number'],
      default: 'auto'
    }
  },
  methods: {
    handleScroll (event) {
      this.$emit('verticalScroll', event)
    }
  },
  render (h) {
    const children = this.$slots.default[0]
    const className = ' sy-scroll-vertical sy-scroll'
    if (!children.data) {
      children.data = {}
    }
    children.data.class = children.data.class
      ? children.data.class + className
      : className
    children.data.on = children.data.on
      ? { ...children.data.on, scroll: this.handleScroll }
      : { scroll: this.handleScroll }
    return children
  }
}
